import { render } from "./SteamDB.vue?vue&type=template&id=ee3a7646&scoped=true"
import script from "./SteamDB.vue?vue&type=script&lang=js"
export * from "./SteamDB.vue?vue&type=script&lang=js"

import "./SteamDB.vue?vue&type=style&index=0&id=ee3a7646&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee3a7646"]])

export default __exports__